module.exports = __webpack_public_path__ + "assets/img/WatchA.cd5524c8.png";